import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Button, Result, Typography, message } from 'antd';
import consts from '../../constant';
const { Paragraph, Text } = Typography;
const Nowallet = () => (
    <Result
        status="error"
        title="No Wallet Found"
        subTitle="Please create a wallet (or) contact Admin"
        extra={[
            <Button type="primary" key="console" href={`/${consts.route}/users`} >
                Go to Users
            </Button >,
            <Button key="buy">Contact Admin</Button>,
        ]}
    >
        {/* <div className="desc">
            <Paragraph>
                <Text
                    strong
                    style={{
                        fontSize: 16,
                    }}
                >
                    The content you submitted has the following error:
                </Text>
            </Paragraph>
            <Paragraph>
                <CloseCircleOutlined className="site-result-demo-error-icon" /> Your account has been
                frozen. <a>Thaw immediately &gt;</a>
            </Paragraph>
            <Paragraph>
                <CloseCircleOutlined className="site-result-demo-error-icon" /> Your account is not yet
                eligible to apply. <a>Apply Unlock &gt;</a>
            </Paragraph>
        </div> */}
    </Result >
);
export default Nowallet;